if (!customElements.get('info-modal')) {
  class InfoModal extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
    }

    connectedCallback() {
      if (this.initialized) return;

      this.buttons = this.querySelectorAll('[data-modal-target]');
      this.modals = this.querySelectorAll('.modal');
      this.closeButtons = this.querySelectorAll('[data-close-modal]');

      if (this.buttons.length === 0 && this.modals.length === 0) {
        this.buttons = document.querySelectorAll('[data-modal-target]');
        this.modals = document.querySelectorAll('.modal');
        this.closeButtons = document.querySelectorAll('[data-close-modal]');
      }

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const modalId = button.getAttribute('data-modal-target');
          const modal = document.getElementById(modalId);
          if (!modal) return;

          modal.style.opacity = '0';
          modal.style.transition = 'opacity 0.15s ease-in-out';

          modal.classList.remove('hidden');
          modal.classList.add('flex');

          modal.offsetHeight;

          modal.style.opacity = '1';
        });
      });

      const closeModal = (modal) => {
        modal.style.opacity = '0';

        setTimeout(() => {
          modal.classList.add('hidden');
          modal.classList.remove('flex');
          modal.style.opacity = '';
        }, 150);
      };

      this.closeButtons.forEach((closeButton) => {
        closeButton.addEventListener('click', () => {
          const modal = closeButton.closest('.modal');
          closeModal(modal);
        });
      });

      this.modals.forEach((modal) => {
        modal.addEventListener('click', (e) => {
          if (e.target === modal) {
            closeModal(modal);
          }
        });
      });

      this.initialized = true;
    }
  }

  window.InfoModal = InfoModal;

  customElements.define('info-modal', InfoModal);
}
